'use strict';

function handleProductBackButton(){
    if ($('#showbacklink').length){
        const backButton = $('.js-hidden-back-button');
        backButton.removeClass('hide');
        backButton.next('.breadcrumb').remove();
    }
}
exports.init = handleProductBackButton;

